export default __webpack_public_path__ + "static/media/download.98bed85d.jpg";